import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom-v5-compat";
import * as yup from "yup";

import { SingleColumnPage } from "./Atoms";
import { Button, Form, RadioSelectField, TextField } from "./Form";
import { useJourney } from "./sign_up_journeys";

const schema = yup
  .object({
    firstName: yup.string().label("First Name").required(),
    lastName: yup.string().label("Last name").required(),
    countryCode: yup.string().ensure().required("Please select a country"),
    role: yup.string().ensure().required("Please select a role"),
  })
  .required();

const InitialCustomerForm = () => {
  const { t } = useTranslation("welcome");
  const {
    saveJourney,
    formProps: { handleSubmit, ...formProps },
  } = useJourney({
    resolver: yupResolver(schema),
  });

  const navigate = useNavigate();
  const onSubmit = async (data) => {
    await saveJourney(data);
    navigate("../your-venue");
  };
  const countries = [
    { value: "NZ", label: t("common.newZealand") },
    { value: "AU", label: t("common.australia") },
    { value: "GB", label: t("common.unitedKingdom") },
    { value: "TO", label: t("common.tonga") },
  ];
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <h1 className="text-center">{t("formContent.whoAreYou")}</h1>
      <input
        type="hidden"
        value="introductions"
        {...formProps.register("currentPage")}
      />
      <div className="flex w-full space-x-32 text-left">
        <div className="flex-1">
          <TextField
            formProps={formProps}
            name="firstName"
            label={t("formContent.firstName")}
          />
        </div>
        <div className="flex-1">
          <TextField
            formProps={formProps}
            name="lastName"
            label={t("formContent.lastName")}
          />
        </div>
      </div>

      <RadioSelectField
        label={t("formContent.yourRole")}
        name="role"
        options={[
          { value: "boss", label: t("formContent.roles.owner") },
          {
            value: "general_manager",
            label: t("formContent.roles.generalManager"),
          },
        ]}
        formProps={formProps}
      />
      <RadioSelectField
        label={t("formContent.country")}
        name="countryCode"
        options={countries}
        formProps={formProps}
      />
      <div className="text-center">
        <Button primary>{t("intro.nextButton")}</Button>
      </div>
    </Form>
  );
};
export const Introductions = ({ progress }) => {
  return (
    <SingleColumnPage progress={progress} content={<InitialCustomerForm />} />
  );
};
